<template>
  <table class="table">
    <thead>
      <tr>
        <th v-for="(header, index) of rows.headers" :key="'header_' + index">
          {{ header }}
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, rowIndex) of rows.body" :key="'row_' + rowIndex">
        <td v-for="(cell, cellIndex) of row" :key="`row_${rowIndex}_cell_${cellIndex}`">
          {{ cell }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
// @vuese
// Tabela z CSV
export default {
  props: {
    // Treść CSV
    csv: { type: Array, required: true }
  },

  computed: {
    rows() {
      const [headers, ...body] = this.csv;
      return { headers, body };
    }
  }
};
</script>

